'use strict';


import { Color, Group, LinearSRGBColorSpace, Mesh, MeshBasicMaterial } from 'three';
import gsap from 'gsap';
import {Cloudflare} from "../../../api/Cloudflare";

export class Windows {
    #active = config.features.liteMode.settings.windows?.active;
    #opacity = config.features.liteMode.settings.windows?.opacity || 0.5;
    #color = config.features.liteMode.settings.windows?.color || '#f2ff00';
    #speed = config.features.liteMode.settings.windows?.speed || 5;
    #timer = 0;
    #url = null;
    #loader = null;
    #ready = false;
    #group = new Group();

    constructor (url,loader) {
        this.#url = `${url}${config.features.liteMode.settings.windows?.path}?v=${Cloudflare.version}` || '';
        this.#loader = loader;
    }

    create() {
        if (!this.#active) return new Promise(resolve => resolve('disabled'));

        return new Promise(resolve => {
            this.#loader.load(this.#url, model => {
                const color = new Color().setStyle(this.#color,LinearSRGBColorSpace);

                model.traverse(el => {
                    if (el.isMesh) {

                        const geometry = el.geometry.clone();
                        const material = new MeshBasicMaterial({
                            depthTest: false,
                            depthWrite: false,
                            transparent: true,
                            opacity: 0,
                            color: color
                        });

                        const mesh = new Mesh(geometry,material);
                        mesh.name = el.name;
                        mesh.scale.copy(el.scale);

                        this.#group.add(mesh);
                    }
                });

                this.#group.name = 'windows';
                this.#ready = true;
                resolve(this.#group);
            });

        });
    }

    updateTime(time){
        if (this.#ready) {
            this.#timer += time;

            if (this.#timer >= this.#speed){
                const randomValue = Math.floor(Math.random() * (this.#group.children.length));
                const randomWindows = this.#group.children[randomValue];

                let opacity;

                if (randomWindows.material.opacity){
                    opacity = 0;
                } else {
                    opacity = this.#opacity;
                }

                gsap.to(randomWindows.material,{
                    duration: 0.4,
                    opacity,
                });

                this.#timer = 0;
            }
        }
    }

    switcher(state) {
        if (this.#ready) {
            switch (state) {
                case 'show':
                    this.#group.visible = true;
                    break;
                case 'hide':
                    this.#group.visible = false;
                    break;

            }
        }
    }
}
